<template>
  <div
    class="d-flex align-center justify-center text-center fill-height"
  >
    <div>
      <Icon
        :width="100"
        :height="100"
        class="mb-4"
        :icon="'link-variant-remove'"
      />
      <h2 style="color: #444">
        {{$t('emptyLink.noResults')}}
      </h2>

      <h3 class="font-weight-regular text-muted mb-5">
        {{$t('emptyLink.message1')}}
      </h3>

      <v-btn
        color="primary"
        href="https://ocularsolution.com"
        role="button"
        target="_blank"
      >
        {{$t('emptyLink.goToOcular')}}
      </v-btn>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class Empty extends Vue {}
</script>
